import { render, staticRenderFns } from "./HealthcardList.vue?vue&type=template&id=50086b84&scoped=true"
import script from "./HealthcardList.vue?vue&type=script&lang=js"
export * from "./HealthcardList.vue?vue&type=script&lang=js"
import style0 from "./HealthcardList.vue?vue&type=style&index=0&id=50086b84&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50086b84",
  null
  
)

export default component.exports